import React from "react";
import { Megaphone } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ annocementsdata, TABLE_HEAD, onEditRow, searching, }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!annocementsdata?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: Megaphone,
            title: "No announcements yet",
            text: "Announcements show as a banner or a section on your website and screens while their dates are on.",
          }
    }
  >
    {annocementsdata?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow} />
    ))}
  </DataTable>
);

export default TableView;
